import React from 'react';
import { Chip } from '@mui/material';
import { TagType } from '@stack/helpers/types';
import { accentColor } from '@stack/theme';

import { TagProps } from './props';

export const Tag: React.FC<TagProps> = (props) => {
  const { category, label, isTextWhite = false, ...chipProps } = props;

  // ======================= VARIABLES
  const colorMap: Record<TagType, { background: string; textColor: string }> = {
    progress: { background: '#3D5AFE1F', textColor: '#3D5AFE' },
    completed: { background: '#67CA241F', textColor: '#67CA24' },
    request: { background: '#FF6F001F', textColor: '#FF6F00' },
    pending: { background: '#F0AD001F', textColor: '#F0AD00' },
    cancel: { background: '#F05A5A1F', textColor: '#F05A5A' },
    primary: { background: accentColor, textColor: '#000' },
    grey: { background: '#6666661F', textColor: '#666666' },
  };

  const { background, textColor } = colorMap[category] || {};

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        background: background || '#000000',
        color: isTextWhite || !textColor ? '#FFFFFF' : textColor,
        fontWeight: 600,
        ...chipProps.sx,
      }}
    />
  );
};

export * from './props';
export default Tag;
